<div class="carousel-container d-flex position-relative"
     [class.vertical]="isVertical"
     [style.width]="!isVertical && sizeItemsContainer"
     [style.height]="isVertical && sizeItemsContainer"
     #mainContainer>
  <div class="icon-container left-btn d-flex align-items-center justify-content-center cursor"
       (click)="moveItemsOnMultipleSteps(false)"
       [style.background-color]="btnColor"
       #leftBtn>
    <kh-img [path]="btnUrl"
            *ngIf="btnUrl"></kh-img>
    <fa-icon [icon]="['fas','angle-left']"
             class="white"
             *ngIf="!btnUrl"></fa-icon>
  </div>
  <div class="content-container" [ngStyle]="{
         'width': !isVertical && sizeItemsContainer,
         'height': isVertical && sizeItemsContainer,
         'padding-top': isVertical ? btnPadding + 'px' : 0,
         'padding-bottom': isVertical ? btnPadding + 'px' : 0,
         'padding-left': !isVertical ? btnPadding + 'px' : 0,
         'padding-right': !isVertical ? btnPadding + 'px' : 0
         }">
    <div class="position-relative content" #carouselContainer>
      <ng-content></ng-content>
    </div>
  </div>
  <div class="icon-container right-btn d-flex align-items-center justify-content-center cursor" (click)="moveItemsOnMultipleSteps(true)" [style.background-color]="btnColor" #rightBtn>
    <kh-img [path]="btnUrl" *ngIf="btnUrl"></kh-img>
    <fa-icon [icon]="['fas','angle-right']" class="white" *ngIf="!btnUrl"></fa-icon>
  </div>
</div>
